import { render } from "./SeasonSeal.vue?vue&type=template&id=28a935d5"
import script from "./SeasonSeal.vue?vue&type=script&lang=js"
export * from "./SeasonSeal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__